import { MEMBERPROJECTS_SUCCESS, MEMBERPROJECTS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const memberProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case MEMBERPROJECTS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case MEMBERPROJECTS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default memberProjectReducer;
